'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var buffer = require('buffer');
var mplCandyGuard = require('@metaplex-foundation/mpl-candy-guard');
var Serializer = require('../../../types/Serializer.cjs');

/**
 * The mintLimit guard allows to specify a limit on the
 * number of mints for each individual wallet.
 *
 * The limit is set per wallet, per candy machine and per
 * identified (provided in the settings) to allow multiple
 * mint limits within a Candy Machine. This is particularly
 * useful when using groups of guards and we want each of them
 * to have a different mint limit.
 *
 * This object defines the settings that should be
 * provided when creating and/or updating a Candy
 * Machine if you wish to enable this guard.
 */

/** @internal */
const mintLimitGuardManifest = {
  name: 'mintLimit',
  settingsBytes: 3,
  settingsSerializer: Serializer.createSerializerFromBeet(mplCandyGuard.mintLimitBeet),
  mintSettingsParser: ({
    metaplex,
    settings,
    payer,
    candyMachine,
    candyGuard,
    programs
  }) => {
    const counterPda = metaplex.candyMachines().pdas().mintLimitCounter({
      id: settings.id,
      user: payer.publicKey,
      candyMachine,
      candyGuard,
      programs
    });
    return {
      arguments: buffer.Buffer.from([]),
      remainingAccounts: [{
        address: counterPda,
        isSigner: false,
        isWritable: true
      }]
    };
  }
};

exports.mintLimitGuardManifest = mintLimitGuardManifest;
//# sourceMappingURL=mintLimit.cjs.map
